export async function imageUrlToFile(url: string, fileName: string) {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], fileName, { type: blob.type });
  return file;
}

export function dataURItoFile(dataURI: string, fileName: string) {
  // convert base64 to raw binary data held in a string
  const byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, { type: mimeString });
}

export const fileToUrl = (file: File, signal: AbortSignal) => {
  return new Promise<string>((resolve, reject) => {
    if (signal.aborted) {
      reject(signal.reason);
    }

    const reader = new FileReader();
    const onLoad = () => {
      reader.removeEventListener('load', onLoad);
      resolve(reader.result as string);
    };
    reader.addEventListener('load', onLoad);

    signal.addEventListener('abort', () => {
      reader.abort();
      reader.removeEventListener('load', onLoad);
      reject(signal.reason);
    });

    reader.readAsDataURL(file);
  });
};
